<div class="reward-history-container"
  [style.height]="histories && histories.length !== 0 ? '100%': 'calc(100vh - 108px)'">
  <app-mobile-header [title]="'label.voucher.history'" [manualBackEvent]="true"
    (onManualBackEvent)="onBack()"></app-mobile-header>

  <div class="rewardHistory-menu">
    <app-button [borderButton]="true" [buttonName]="'label.all' | translate" (onClickEvent)="onMenuChange()"
      [ngClass]="{'active' : voucherStatus != voucherStatusFlag.Used && voucherStatus != voucherStatusFlag.Expired }"></app-button>
    <app-button [borderButton]="true" [buttonName]="'label.used' | translate"
      (onClickEvent)="onMenuChange(voucherStatusFlag.Used)"
      [ngClass]="{'active' : voucherStatus == voucherStatusFlag.Used }"></app-button>
    <app-button [borderButton]="true" [buttonName]="'label.expired' | translate"
      (onClickEvent)="onMenuChange(voucherStatusFlag.Expired)"
      [ngClass]="{'active' : voucherStatus == voucherStatusFlag.Expired}"></app-button>
  </div>

  <div class="history-card-listing" *ngIf="histories && histories.length !== 0">
    <div *ngFor="let history of histories">
      <app-reward-card [historyReward]="history" [customCardType]="checkCardType(history.statusFlag)"></app-reward-card>
    </div>
  </div>

  <ng-template [ngIf]="histories && histories.length <= 0 && !isOnListLoad && !isOnLoad">
    <div class="no-reward-found-container">
      <img src="assets/generalImage/empty.svg">
      <h1 class="title">{{'desc.no.voucher.found' | translate}}</h1>
      <p class="desc">{{'desc.no.voucher.found.start.exploring' | translate}}</p>
      <app-button [textButton]="true" [buttonName]="'button.explore' | translate"
        (onClickEvent)="onClickExplore()"></app-button>
    </div>
  </ng-template>

  <ng-template [ngIf]="isOnListLoad">
    <div class="pagination-loader">
      <ng-lottie [options]="{path: '/assets/loader/E-order-loading.json'}"></ng-lottie>
    </div>
  </ng-template>
</div>